<div class="po-details">
    <!-- <div class="modal-header">
        <div class="row w-100">
            <div class="col-md-11">
                <h4 class="modal-title">Details</h4>
            </div>
            <div class="col-md-1">
                <app-print-common [rowData]="rowData" [columns]="columns"></app-print-common>
            </div>
        </div>
    </div> -->
    <div class="modal-body">

        <div class="card p-3 mb-2">
            <div class="row py-1">
                <div class="border-right" [ngClass]="userType==='CUSTOMER' ? 'col-sm-4 ':'col-sm-5'">
                    <h2>General Information</h2>
                    <p class="mb-2" *ngIf="userType==='CUSTOMER'">
                        <label class="form-label-order">Customer:&nbsp;</label>
                        <span>{{rowData?.accountName}}</span>
                    </p>
                    <p class="mb-2">
                        <label class="form-label-order">Tonnage:&nbsp;</label>
                        <span>{{ rowData?.tonnage ? rowData?.tonnage : parentOrder?.tonnage }}</span>
                    </p>
                    <!-- <p class="mb-2">
                        <label class="form-label-order">Number of Labourers: </label>
                        <span></span>
                    </p> -->
                    <!-- <p class="mb-2">
                        <label class="form-label-order">Shift Date & Time: </label>
                        <span></span>
                    </p> -->
                    <p class="mb-2">
                        <label class="form-label-order">Status:&nbsp;</label>
                        <span [ngClass]="
                        {
                            'draft': rowData?.status == 'Draft',
                            'primaryPill': rowData?.status == 'Created' ||  rowData?.status == 'Closed',
                            'commentedPill': rowData?.status == 'PendingOnVendor' || rowData?.status == 'PendingOnCustomer',
                            'successPill': rowData?.status == 'AcceptedByVendor' || rowData?.status == 'AcceptedByCustomer' || rowData?.status == 'Completed',
                            'errorPill': rowData?.status == 'Cancel'|| rowData?.status == 'RejectedByVendor' || rowData?.status == 'RejectedByCustomer' || rowData?.status == 'Expire',
                        }">{{getStatusText(rowData?.status , userType)}}</span>
                    </p>
                    <p class="mb-2">
                        <label class="form-label-order">Date/Time of Placement:&nbsp;</label>
                        <span>{{rowData?.fromDate | CustomDatePipe: 'DD-MM-YYYY HH:mm:ss Z'}} </span>
                    </p>
                </div>
                <ng-container *ngIf="userType==='VENDOR'">
                    <div class="" [ngClass]="userType==='CUSTOMER' ? '':'col-sm-1'"></div>
                </ng-container>
                <div class="" [ngClass]="userType==='CUSTOMER' ? 'col-sm-4 border-right':'col-sm-6'">
                    <div class="mb-3">
                        <h2>3PL Contact Detail</h2>
                        <p class="mb-2">
                            <label class="form-label-order">Name:&nbsp; </label>
                            <span>{{rowData?.ascContactName}}</span>
                        </p>
                        <p class="mb-2">
                            <label class="form-label-order">Mobile Number:&nbsp;</label>
                            <span>{{rowData?.ascContactMobile}}</span>
                        </p>
                        <p class="mb-2">
                            <label class="form-label-order">Email:&nbsp;</label>
                            <span>{{rowData?.ascContactEmail}}</span>
                        </p>
                    </div>
                </div>
                <div class="col-sm-4" *ngIf="userType==='CUSTOMER'">
                    <div class="mb-3">
                        <h2>Customer POC Details</h2>
                        <p class="mb-2">
                            <label class="form-label-order">Name:&nbsp; </label>
                            <span>{{rowData?.contactName}}</span>
                        </p>
                        <p class="mb-2">
                            <label class="form-label-order">Mobile Number:&nbsp;</label>
                            <span>{{rowData?.contactMobile}}</span>
                        </p>
                        <p class="mb-2">
                            <label class="form-label-order">Email:&nbsp;</label>
                            <span>{{rowData?.contactEmail}}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>


        <div class="card p-3 mb-2">
            <div class="table-responsive-scroll">
                <div class="mt-0 mb-2">
                    <h2>
                        <span>Route Details</span>
                    </h2>
                </div>

                <table class="table mt-2 counter-table">
                    <thead>
                        <tr>
                            <th class="sticky-col" rowspan="">Route</th>
                            <th class="sticky-col" rowspan="">Vehicle Type</th>
                            <th style="width: 150px;">No Of Vehicle</th>
                            <th style="width: 150px;">Price</th>
                        </tr>
                        <!-- <tr>
                            <th>No Of Vehicle</th>
                            <th>Price</th>
                        </tr> -->
                    </thead>
                    <tbody>
                        <tr *ngFor="let group of parentOrder?.jobLineItems; let i = index">
                            <td class="sticky-col">
                                 <a class="linklick" (click)="viewPickUpDropLocation(group)">
                                <ng-container *ngIf="group?.routeCode; else noRoute">
                                    {{ group?.routeCode }}: {{ group?.routeSource }} - {{ group?.routeDestination }}
                                </ng-container>
                                <ng-template #noRoute>
                                    {{ group?.sourceText }} - {{ group?.destinationText }}
                                </ng-template>
                                </a>
                            </td>
                            <td class="customer-column">{{ group?.vehicleType }}</td>
                            <td class="customer-column">{{ group?.numberOfVehicle }}</td>
                            <td class="customer-column">{{ group?.maxSalary }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <ng-container *ngIf="rowData?.status != 'Created'">
            <div class="table-responsive-scroll" *ngIf="userType==='CUSTOMER'">
                <table class="table mt-2 counter-table">
                    <thead>
                        <tr>
                            <th rowspan="2">Action</th>
                            <th rowspan="2">Updated By</th>
                            <th rowspan="2">Vendor Name</th>
                            <th rowspan="2">Whatsapp</th>
                            <th rowspan="2" (click)="sortData('status')"> Status <span class="svg-sort"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span></th>
                            <!-- <th class="sticky-col" rowspan="2" style="width: 100px;">Route</th> -->
                            <th colspan="2" class="text-center">Vendor Proposal</th>
                            <th colspan="2" class="text-center">Customer Price</th>
                            <th rowspan="2" class="text-center">Rank</th>
                            <!-- <th colspan="2" class="text-center">Proposal</th> -->
                        </tr>

                        <tr>
                            <th (click)="sortData('jobLineItems.vehicleProvide')">No Of Vehicle <span class="svg-sort"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span></th>
                            <th (click)="sortData('jobLineItems.vendorPrice')">Price <span class="svg-sort"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span></th>
                            
                            <th (click)="sortData('jobLineItems.numberOfVehicle')">No Of Vehicle <span class="svg-sort"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span></th>
                            <th (click)="sortData('jobLineItems.maxSalary')">Price <span class="svg-sort"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span></th>
                            
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let group of groupedLineItems; let i = index">
                            <!-- {{group | json}} -->
                            <td align="center">
                                <div class="btn-block mt-3" *ngIf="group?.status !== 'Cancel' && group?.status !== 'Closed' && group?.status !== 'Expire'">
                                    <ng-container *ngIf="customerAccRejectBtn(group)">
                                        <button class="btn btn-primary mr-2"
                                            (click)="orderUpdate(group, 'ACCEPT')">Accept</button> <br />
                                        <button class="btn btn-primary reject mr-2"
                                            (click)="orderUpdate(group, 'REJECT')">Reject</button>
                                    </ng-container>
                                    <div
                                        *ngIf="jobDetails?.[0]?.counterNumber !== null && jobDetails?.[0]?.counterNumber < 3">
                                        <div *ngIf="hasCustomerStatus(group)">
                                            <button class="btn btn-primary" style="height: 30px;"
                                                (click)="showCounterpopUp(group)">
                                                {{ group.showCounter ? 'Cancel' : 'Create Counter' }}
                                            </button>
                                        </div>
                                    </div>
                                    <!-- <span *ngIf="group.showCounter" class="text-right">
                                        <button class="btn btn-success" (click)="submitCounter(group)">
                                            Submit Counter
                                        </button>
                                    </span> -->
                                </div>
                            </td>
                            <td style="width:120px" >
                                {{group.updatedByName}} 
                            </td>
                            <td style="width:120px" [attr.rowspan]="group.length">
                                <a class="linklick" style="width: 150px;display: inline-block;white-space: break-spaces;" (click)="transactionPraposal(group)">{{group.vendorName}} </a>
                            </td>
                            <td style="width:120px;text-align: center;" >
                                <div class="notificationStatus">
                                {{group.notificationStatus == 'SENT'? '✅':'❌' }}

                                <ul class="notificationTable" *ngIf="group.notificationStatus">
                                    <li class="notihead">
                                        <div>
                                            <b>Recipient Name</b>
                                        </div>
                                        <div><b>Recipient Number</b></div>
                                        <div>
                                            <b>Status</b>
                                        </div>
                                    </li>
                                    <li *ngFor="let log of whatsApplogData(group?.childJobCode)">
                                        <div>{{log?.recipientName}}</div>
                                        <div>
                                            {{ log.recipientMobileNumber }}
                                        </div>
                                        <div>
                                            {{ log.notificationStatus }}
                                        </div>
                                    </li>

                                </ul>
                                </div>
                            </td>
                            <td>
                                <p class="mb-0">
                                    <span [ngClass]="
                                        {
                                            'draft': group?.status == 'Draft',
                                            'primaryPill': group?.status == 'Created' ||  group?.status == 'Closed',
                                            'commentedPill': group?.status == 'PendingOnVendor' || group?.status == 'PendingOnCustomer',
                                            'successPill': group?.status == 'AcceptedByVendor' || group?.status == 'AcceptedByCustomer',
                                            'errorPill': group?.status == 'Cancel'|| group?.status == 'RejectedByVendor' || group?.status == 'RejectedByCustomer' || group?.status == 'Expire',
                                        }">{{getStatusText(group?.status , userType)}}</span>
                                </p>
                            </td>
                            <!-- <td class="sticky-col" style="width:100px">
                                {{group?.items[0]?.routeCode}}: {{ group?.items[0]?.routeSource }} -
                                {{group?.items[0]?.routeDestination}}
                            </td> -->
                            <td class="customer-column" [ngClass]="group?.finalAcceptance == 'VENDOR' && group?.status == 'AcceptedByCustomer' ? 'accepted-price':''">{{ group.items[0]?.vehicleProvide || '' }} </td>
                            <td class="customer-column" [ngClass]="group?.finalAcceptance == 'VENDOR' && group?.status == 'AcceptedByCustomer' ? 'accepted-price':''">{{ group.items[0]?.vendorPrice || '' }}</td>
                            <td class="customer-column" [ngClass]="group?.finalAcceptance == 'CUSTOMER' && group?.status == 'AcceptedByCustomer' ? 'accepted-price':''">
                                {{ 
                                (group?.counterNumber == 0 && group?.status == 'AcceptedByCustomer') 
                                    ? group.items[0].numberOfVehicle 
                                    : (group?.counterNumber == 0 || group?.status == 'PendingOnCustomer') 
                                    ? '' 
                                    : group.items[0].numberOfVehicle 
                                }}

                                <!-- {{ group?.counterNumber == 0 || ( group?.status == 'PendingOnCustomer')? '' : group.items[0].numberOfVehicle}} -->
                            </td>
                            <td class="customer-column" [ngClass]="group?.finalAcceptance == 'CUSTOMER' && group?.status == 'AcceptedByCustomer' ? 'accepted-price':''">
                               {{ 
                                (group?.counterNumber == 0 && group?.status == 'AcceptedByCustomer') 
                                    ? group.items[0].maxSalary 
                                    : (group?.counterNumber == 0 || group?.status == 'PendingOnCustomer') 
                                    ? '' 
                                    : group.items[0].maxSalary 
                                }}
                                <!-- {{ group?.counterNumber == 0 || (group?.status =='PendingOnCustomer' )? '' : group.items[0].maxSalary}} -->
                            </td>
                            <td [attr.rowspan]="group.length" [ngStyle]="{padding: !group?.rank ? 0 :''}" style="border-top: 1px solid #dee2e6;">
                                <span class="rank-chip" *ngIf="group?.rank">{{group?.rank}}</span>
                            </td>
                            <!-- <td class="customer-column">{{ group.items[0]?.numberOfVehicle }}</td> -->
                            <!-- <td class="customer-column">{{ group.items[0]?.maxSalary }}</td> -->
                        </tr>
                    </tbody>
                </table>
            </div>
        </ng-container>

        <!-- TABS -->
        <div class="relative-card" *ngIf="jobDetails?.length" style="display:none">
            <ul class="tabs">
                <li *ngFor="let vendor of jobDetails; let i = index" [class.active-tab]="i === activeTabIndex"
                    (click)="onVendorTabClick(i)">
                    {{ vendor?.vendorName }}
                </li>
            </ul>
        </div>

        <!-- PENDING/APPROVE/REJECT order Proposal -->
        <ng-container *ngIf="userType==='CUSTOMER'">
            <ng-container *ngFor="let group of groupedLineItems; let gIndex = index">
                <div class="card p-3 mb-2" style="display:none">
                    <div class="row">
                        <div class="col">
                            <h2>
                                <span
                                    *ngIf="group.status === STATUS.PendingOnCustomer || group.status === STATUS.PendingOnVendor"
                                    style="color: var(--background-primary-color);">
                                    Current Open
                                </span>
                                <span *ngIf="group.status === STATUS.AcceptedByCustomer" class="text-success">
                                    Accepted
                                </span>
                                <span *ngIf="group.status === STATUS.RejectedByCustomer" class="text-danger">
                                    Rejected
                                </span>
                                <span>Bid -&nbsp;</span>
                                <span style="color: var(--background-primary-color);">{{ group.vendorName }}</span>
                            </h2>

                        </div>
                        <!-- <ng-container *ngIf="jobDetails?.[0]?.counterNumber !== null && jobDetails?.[0]?.counterNumber < 3">
                            <div class="col-4 d-flex justify-content-end" *ngIf="hasCustomerStatus()">
                            <button class="btn btn-primary" style="height: 30px;" (click)="toggleCounterMode(group)">
                                {{ group.showCounter ? 'Cancel' : 'Create Counter Proposal' }}
                            </button>
                        </div>
                        </ng-container> -->
                    </div>

                    <div class="table-responsive-scroll">
                        <table class="table mt-2 counter-table">
                            <thead>
                                <tr>
                                    <!-- <th rowspan="3">Proposal</th> -->
                                    <th class="sticky-col" rowspan="3">Route</th>
                                    <th colspan="2" class="text-center">Customer</th>
                                    <th colspan="2" class="text-center" *ngIf="hasVendorData(group)">Vendor</th>
                                    <th colspan="2" class="text-center" *ngIf="group.showCounter">Proposal</th>
                                </tr>
                                <tr>
                                    <th>No Of Vehicle</th>
                                    <th>Basic Wage</th>
                                    <th *ngIf="hasVendorData(group)">No Of Vehicle</th>
                                    <th *ngIf="hasVendorData(group)">Basic Wage</th>
                                    <th *ngIf="group.showCounter">No Of Vehicle</th>
                                    <th *ngIf="group.showCounter">Basic Wage</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of group.items; let i = index">
                                    <!-- <td>{{item.}}</td> -->
                                    <td class="sticky-col">{{ item.routeId }}

                                    </td>
                                    <td class="customer-column">{{ item.numberOfVehicle }}</td>
                                    <td class="customer-column">{{ item.maxSalary }}</td>
                                    <td class="vendor-column" *ngIf="hasVendorData(group)">{{ item.vendorCount }}</td>
                                    <td class="vendor-column" *ngIf="hasVendorData(group)">{{ item.vendorPrice }}</td>
                                    <td *ngIf="group.showCounter">
                                        <input type="text" class="form-control"
                                            [(ngModel)]="group.counterInputs[i].numberOfVehicle"
                                            [placeholder]="item.numberOfVehicle"
                                            (keypress)="sharedService.isNumberKey($event)" />
                                    </td>
                                    <td *ngIf="group.showCounter">
                                        <input type="text" class="form-control"
                                            [(ngModel)]="group.counterInputs[i].maxSalary"
                                            [placeholder]="item.maxSalary"
                                            (keypress)="sharedService.isNumberKey($event)" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <ng-container>
                        <div class="btn-block mt-3" *ngIf="rowData?.status != 'Cancel'">
                            <ng-container *ngIf="customerAccRejectBtn(rowData)">
                                <button class="btn btn-primary mr-2"
                                    (click)="orderUpdate(group, 'ACCEPT')">Accept</button>
                                <button class="btn btn-primary reject mr-2"
                                    (click)="orderUpdate(group, 'REJECT')">Reject</button>
                            </ng-container>
                            <span *ngIf="group.showCounter" class="text-right">
                                <button class="btn btn-success" (click)="submitCounter(group)">
                                    Submit Counter
                                </button>
                            </span>
                        </div>
                    </ng-container>


                </div>
            </ng-container>

        </ng-container>

        <!-- Pending Card Table (PendingOnVendor) -->
        <ng-container *ngIf="userType==='VENDOR'">
            <ng-container *ngFor="let group of pendingLineItems; let gIndex = index">
                <div class="card p-3 mb-2">
                    <div class="row">
                        <div class="col">
                            <h2>
                                <span
                                    *ngIf="rowData.status === STATUS.PendingOnCustomer || rowData.status === STATUS.PendingOnVendor"
                                    class="text-primary">
                                    Current Open
                                </span>
                                <span *ngIf="rowData.status === STATUS.AcceptedByCustomer" class="text-success">
                                    Accepted
                                </span>
                                <span *ngIf="rowData.status === STATUS.RejectedByCustomer" class="text-danger">
                                    Rejected
                                </span>
                                <span>Bid</span>
                                <!-- <span style="color: var(--background-primary-color);">{{ rowData?.accountName }}</span> -->
                            </h2>
                        </div>
                        <ng-container *ngIf="rowData?.counterNumber !== null && rowData?.counterNumber < 3 ">
                            <div class="col-4 d-flex justify-content-end" *ngIf="hasVendorStatus()">
                                <button *ngIf=" rowData?.status != 'PendingOnCustomer' &&  rowData?.status != 'PendingOnCustomer' &&  rowData?.status != 'Closed'" class="btn btn-primary"
                                    style="height: 30px;" (click)="toggleCounterMode(group)">
                                    {{ group.showCounter ? 'Cancel' : 'Create Counter Proposal' }}
                                </button>
                            </div>
                        </ng-container>
                    </div>

                    <div class="table-responsive-scroll">
                        <table class="table mt-2 counter-table">
                            <thead>
                                <tr>
                                    <!-- <th rowspan="3">Proposal</th> -->
                                    <th class="sticky-col" rowspan="3">Vendor Name</th>
                                    <th colspan="2" class="text-center">Customer</th>
                                    <!-- <th colspan="2" class="text-center" *ngIf="hasVendorData(group)">Vendor</th> -->
                                    <th colspan="2" class="text-center" *ngIf="!group.showCounter">Vendor</th>
                                    <th colspan="2" class="text-center" *ngIf="group.showCounter">Proposal</th>
                                    <th class="sticky-col" rowspan="3">Rank</th>
                                </tr>
                                <tr>
                                    <th>No Of Vehicle</th>
                                    <th>Price</th>
                                    <th *ngIf="!group.showCounter">No Of Vehicle</th>
                                    <th *ngIf="!group.showCounter">Price</th>
                                    <th *ngIf="group.showCounter">No Of Vehicle</th>
                                    <th *ngIf="group.showCounter">Price</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of group.items; let i = index">
                                    <!-- <td>{{item.}}</td> -->
                                    <!-- <td class="sticky-col">
                                        {{item?.routeCode}}: {{ item?.routeSource }} - {{item?.routeDestination}}
                                    </td> -->
                                    <td style="width:120px" [attr.rowspan]="group.length">
                                        <a class="linklick"
                                            (click)="transactionPraposal(group)">{{group.vendorName}}</a>
                                    </td>
                                    <!-- <td class="customer-column">{{rowData?.counterNumber == 0 ? '':item.numberOfVehicle}}</td>
                                    <td class="customer-column">{{rowData?.counterNumber == 0 ? '':item.maxSalary}}</td> -->
                                    <td class="customer-column">{{item.numberOfVehicle}}</td>
                                    <td class="customer-column">{{item.maxSalary}}</td>
                                    <!-- <td class="customer-column">{{ item.maxSalary }}</td> -->
                                    <ng-container *ngIf="!group.showCounter">

                                        <td class="vendor-column">{{ (group?.status != 'PendingOnCustomer' &&
                                            group?.status != 'RejectedByCustomer' ) ? '' : item?.vehicleProvide }}</td>
                                        <td class="vendor-column">{{ (group?.status != 'PendingOnCustomer' &&
                                            group?.status != 'RejectedByCustomer' ) ? '' : item?.vendorPrice }}</td>
                                    </ng-container>

                                    <td *ngIf="group.showCounter">
                                        <input type="text" class="form-control"
                                            [(ngModel)]="group.counterInputs[i].vehicleProvide"
                                            (ngModelChange)="validateVehicleProvide(i, group)"
                                            (keypress)="sharedService.isNumberKey($event)" />
                                        <div *ngIf="vehicleProvideError" class="text-danger">
                                            Cannot exceed {{ item.numberOfVehicle }}
                                        </div>
                                    </td>
                                    <td *ngIf="group.showCounter">
                                        <input type="text" class="form-control"
                                            [(ngModel)]="group.counterInputs[i].vendorPrice"
                                            (ngModelChange)="validateVendorPrice(i, group)"
                                            (keypress)="sharedService.isNumberKey($event)" />
                                        <div *ngIf="vendorPriceError" class="text-danger">
                                            your current price is not more than {{ item.vendorPrice }} price
                                        </div>
                                    </td>
                                    <td [attr.rowspan]="group.length" [ngStyle]="{padding: !group?.rank ? 0 :''}" style="border-top: 1px solid #dee2e6;">
                                        <span class="rank-chip" *ngIf="group?.rank">{{group?.rank}}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <ng-container *ngIf="rowData?.status != 'PendingOnCustomer' && rowData?.status != 'Closed' && rowData?.status != 'Expire'">
                        <div class="btn-block mt-3">
                            <ng-container *ngIf="hasVendorStatus()">
                                <button class="btn btn-primary mr-2"
                                    (click)="orderUpdate(group, 'ACCEPT')">Accept</button>
                                <button class="btn btn-primary reject mr-2"
                                    (click)="orderUpdate(group, 'REJECT')">Reject</button>
                            </ng-container>
                            <span *ngIf="group.showCounter" class="text-right">
                                <button class="btn btn-success" (click)="submitCounter(group)">
                                    Submit Counter
                                </button>
                            </span>
                            <!-- <span>
                                <button class="btn btn-primary mr-2"
                                    *ngIf="rowData?.status === STATUS.AcceptedByCustomer" (click)="pushToAssociate()">
                                    Push To Associate
                                </button>
                            </span> -->
                        </div>
                    </ng-container>
                </div>
            </ng-container>
        </ng-container>






        <!-- <div class="btn-block mt-3">
            <button class="btn btn-primary mr-2" (click)="orderUpdate(groupedLineItems, 'ACCEPT')">Accept</button>
            <button class="btn btn-primary reject mr-2"
                (click)="orderUpdate(groupedLineItems, 'REJECT')">Reject</button>
        </div> -->



    </div>

    <div class="btn-wrapper mt-2">
        <button class="btn btn-primary mr-2" (click)="editEvent()" *ngIf="userType==='CUSTOMER' && rowData.status === 'Created'">Edit</button>
        <button class="btn btn-primary mr-2" (click)="pushToAssociate()" 
        *ngIf="userType==='CUSTOMER' && 
        (rowData.status != 'Cancel' && rowData.status !== 'RejectedByCustomer' && rowData.status !== 'Completed' && rowData.status !== 'Expire') ">Push To
            Vendor</button>
        <ng-container *ngIf="userType === 'CUSTOMER' && (rowData.status != 'Cancel' && rowData.status != 'RejectedByCustomer'
            && rowData.status != 'Completed'
        )">
            <button *ngIf="showCancelBtn" class="btn btn-danger" (click)="cancelOrder()">Cancel Order</button>
        </ng-container>
    </div>
</div>



<p-dialog header="Creater Counter Proposal" [modal]="true" [(visible)]="createCounterPopup" (onHide)="onCounterPopupClose()"
    [style]="{ width: '25rem' }">
    <!-- {{createCounterData|json}} --><br />
    <div style="margin-bottom: 5px;">
        <label>No. Of Vehicle</label>
        <input type="text" class="form-control" [(ngModel)]="customerMumberOfVehicle"
            (keypress)="sharedService.isNumberKey($event)" />
    </div>
    <div>
        <label>Price</label>

        <input type="text" class="form-control" [(ngModel)]="customerMaxSalary"
            (keypress)="sharedService.isNumberKey($event)" />
    </div>

    <div class="flex justify-end gap-2 mt-4">
        <a class="btn btn-primary" (click)="submitCounterCustomer(createCounterData)">Create Counter</a>
        <!-- <a class="btn btn-primary btn-denger" (click)="approveClick('reject')">Reject</a> -->
    </div>
</p-dialog>




<p-dialog header="Order Bidding History" [modal]="true" [(visible)]="BiddingHistoryPopup" [style]="{ width: '60rem' }">
    <!-- Cancel Card Table -->
    <ng-container *ngIf="transactionData?.length > 0">
        <div class="carda p-0 mt-4">
            <!-- <div class="row">
                    <div class="col">
                        <h2>Order Bidding History</h2>
                    </div>
                </div> -->

            <div class="table-responsive-scroll">
                <table class="table mt-0 counter-table">
                    <thead>
                        <tr>
                            <th rowspan="3">Counter </th>
                            <!-- <th rowspan="3">Route</th> -->
                            <ng-container *ngIf="userType === 'VENDOR'">
                                <th colspan="2" class="text-center">Customer</th>
                                <th colspan="2" class="text-center">Vendor</th>
                            </ng-container>
                            <ng-container *ngIf="userType === 'CUSTOMER'">
                                <th colspan="2" class="text-center">Vendor</th>
                                <th colspan="2" class="text-center">Customer</th>
                            </ng-container>
                        </tr>
                        <tr>
                            <th>No Of Vehicle</th>
                            <th>Price</th>
                            <th>No Of Vehicle</th>
                            <th>Price</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let group of transactionDataTransform">
                            <ng-container *ngFor="let row of group.rows; let i = index">
                                <tr>
                                    <!-- show counter only for the first row with rowspan -->
                                    <td *ngIf="i === 0" [attr.rowspan]="group.rows.length">Counter {{ group.counter }}
                                    </td>
                                    <!-- <td>
                                        <ng-container>
                                            {{row?.routeCode}}: {{ row?.routeSource }} - {{row?.routeDestination}}
                                        </ng-container>
                                    </td> -->
                                    <ng-container *ngIf="userType === 'VENDOR'">
                                        <td>{{ row.numberOfVehicle }}</td>
                                        <td>{{ row.maxSalary }}</td>
                                        <td>{{ row.vehicleProvide }}</td>
                                        <td>{{ row.vendorPrice }}</td>
                                    </ng-container>
                                    <ng-container *ngIf="userType === 'CUSTOMER'">
                                        <td>{{ row.vehicleProvide }}</td>
                                        <td>{{ row.vendorPrice }}</td>
                                        <td>{{ row.numberOfVehicle }}</td>
                                        <td>{{ row.maxSalary }}</td>
                                    </ng-container>

                                </tr>
                            </ng-container>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="transactionData?.length == 0">
        <p style="color: red;margin: 30px 0 0;">No Order Bidding History</p>
    </ng-container>

</p-dialog>







<p-dialog header="View Location" [modal]="true" [(visible)]="viewPickupPopup" (onHide)="viewPickupPopupClose()"
    [style]="{ width: '40rem' }">
    
    <div class="location-row">
        <div class="pickup">
            <h2>Pick Up Location</h2>
            <ul>
                <li *ngFor="let loc of viewPickupPopupData?.sourceCities">
                    <p>Address:</p>
                    <span>{{loc?.city}} {{loc?.address}} {{loc?.pincode}} </span>
                </li>
            </ul>
        </div>
        <div class="pickup">
            <h2>Drop Location</h2>
            <ul>
            <li *ngFor="let loc of viewPickupPopupData?.destinationCities">
                <p>Address:</p>
                <span>{{loc?.city}} {{loc?.address}} {{loc?.pincode}} </span>
            </li>
            </ul>
        </div>
    </div>
    <!-- {{viewPickupPopupData|json}} -->
</p-dialog>
